const dict = {
  uk: {
    // Skill labels (used in SKILLS array)
    skills: {
      listening: 'Аудіювання',
      speaking: 'Говоріння',
      reading: 'Читання',
      writing: 'Письмо',
    },
    // Listening task instructions (shown under video)
    listeningInstructions: {
      multipleChoice: 'Подивіться відео та оберіть правильну відповідь.',
      trueFalse: 'Подивіться відео. Чи правдиве твердження?',
      fillGap: 'Подивіться відео та заповніть пропуск словом, яке ви почули.',
      wordMeaning: 'Подивіться відео. Що означає виділене слово в цьому контексті?',
      idiomMeaning: 'Подивіться відео. Що означає виділена ідіома в цьому контексті?',
      bestResponse: 'Подивіться відео. Яка відповідь найкраще продовжить розмову?',
    },
    // Speech recognition errors
    speech: {
      notSupported: 'Ваш браузер не підтримує розпізнавання мовлення. Спробуйте Chrome, Edge або Safari.',
      notSupportedLong: 'Ваш браузер не підтримує розпізнавання мовлення. Спробуйте Chrome, Edge або Safari, або натисніть "Я не знаю".',
      micDenied: 'Доступ до мікрофона заборонено. Дозвольте доступ у налаштуваннях браузера.',
      noSpeech: 'Не почули жодного слова. Спробуйте ще раз.',
      recognitionError: 'Помилка розпізнавання. Спробуйте ще раз.',
      startFailed: 'Не вдалося запустити мікрофон. Спробуйте ще раз.',
    },
    // Answer status
    answer: {
      notAnswered: 'Не відповіли',
      dontKnow: 'Я не знаю',
      unknown: 'Невідома відповідь',
      empty: '(пусто)',
    },
    // Header titles per stage
    header: {
      intro: 'Тест на визначення рівня',
      skillResult: 'Результат навички',
      reviewAnswers: 'Перегляд відповідей',
      results: 'Результати тесту',
    },
    // Progress bar
    progress: {
      completedSkills: 'Завершено навичок: {{completed}} з {{total}}',
    },
    // Loading / errors
    loadingResults: 'Завантаження результатів...',
    // Intro stage
    intro: {
      heading: 'Визначте свій рівень англійської',
      shortDesc: 'Швидкий тест: аудіювання та читання (~10-15 хвилин) — щоб орієнтовно оцінити ваш рівень. Пізніше в профілі можна пройти повний тест для точнішої оцінки.',
      fullDesc: 'Цей тест допоможе оцінити ваші навички з 4 ключових аспектів англійської мови:',
      resumeBanner: 'Ви вже пройшли {{completed}} з {{total}} навичок. Продовжте тест!',
      remainingText: 'Залишилось {{remaining}} навичок. Ви можете продовжити в будь-який час.',
      shortTimeHint: 'Тест займе близько 10-15 хвилин. Для розділу "Вимова" знадобиться мікрофон.',
      fullTimeHint: 'Кожен тест займе приблизно 20-30 хвилин. Ви отримаєте окрему оцінку для кожної навички і дізнаєтесь свій справжній рівень англійської.',
      noUserError: 'Помилка: не вдалося визначити користувача. Спробуйте перезавантажити сторінку.',
      continueTest: 'Продовжити тест',
      startTest: 'Розпочати тест',
      viewResults: 'Переглянути результати',
    },
    // Testing stage
    testing: {
      questionOf: 'Питання {{current}} з {{total}}',
      videoNotLoaded: 'Відео ще не завантажено',
      answerPlaceholder: 'Відповідь {{index}}',
      pronunciationInstruction: 'Натисніть кнопку мікрофона і чітко скажіть слово вголос.',
      listening: 'Слухаю...',
      recorded: 'Готово. Можна перезаписати або перейти далі.',
      pressToRecord: 'Натисніть для запису',
      weHeard: 'Ми почули:',
      pressToListen: 'Натисніть, щоб прослухати',
      fillGaps: 'Заповніть пропуски:',
      writeCorrected: 'Напишіть виправлене речення:',
      correctedPlaceholder: 'Введіть виправлений варіант...',
      finishSentence: 'Допишіть речення:',
      yourAnswerPlaceholder: 'Введіть вашу відповідь...',
      saving: 'Збереження...',
      nextQuestion: 'Наступне питання',
      finishSkill: 'Завершити навичку',
    },
    // Skill result stage
    skillResult: {
      completed: '{{skill}} - Завершено!',
      yourLevel: 'Ваш рівень:',
      reviewAnswers: 'Переглянути відповіді',
      skillsPassed: 'Пройдено навичок: {{completed}} з {{total}}',
      viewAllResults: 'Переглянути всі результати',
      continueTest: 'Продовжити тест',
      finishLater: 'Завершити пізніше',
    },
    // Review answers stage
    review: {
      backToResults: 'Назад до результатів',
      unavailable: 'Відповіді недоступні для перегляду.',
      unavailableHint: 'Детальний перегляд доступний тільки одразу після проходження тесту.',
      question: 'Питання {{index}}',
      correct: '✓ Правильно',
      wrong: '✗ Неправильно',
      sayWord: 'Скажіть слово: {{word}}',
      sayWordWithPhonetic: 'Скажіть слово: {{word}} {{phonetic}}',
      yourAnswer: 'Ваша відповідь:',
      correctAnswer: 'Правильна відповідь:',
    },
    // Results stage
    results: {
      testFinished: 'Тест завершено!',
      yourResults: 'Ваші результати',
      resultsBySkill: 'Ваші результати за кожною навичкою:',
      skillsPassedSummary: 'Пройдено {{completed}} з {{total}} навичок',
      continueTest: 'Продовжити тест',
      close: 'Закрити',
      saveResults: 'Зберегти результати',
    },
  },
  en: {
    // Skill labels
    skills: {
      listening: 'Listening',
      speaking: 'Speaking',
      reading: 'Reading',
      writing: 'Writing',
    },
    listeningInstructions: {
      multipleChoice: 'Watch the video and choose the correct answer.',
      trueFalse: 'Watch the video. Is the statement true?',
      fillGap: 'Watch the video and fill the gap with the word you heard.',
      wordMeaning: 'Watch the video. What does the highlighted word mean in this context?',
      idiomMeaning: 'Watch the video. What does the highlighted idiom mean in this context?',
      bestResponse: 'Watch the video. Which response best continues the conversation?',
    },
    speech: {
      notSupported: 'Your browser does not support speech recognition. Try Chrome, Edge or Safari.',
      notSupportedLong: 'Your browser does not support speech recognition. Try Chrome, Edge or Safari, or press "I don\'t know".',
      micDenied: 'Microphone access denied. Please allow access in your browser settings.',
      noSpeech: 'We did not hear any words. Please try again.',
      recognitionError: 'Recognition error. Please try again.',
      startFailed: 'Could not start the microphone. Please try again.',
    },
    answer: {
      notAnswered: 'Not answered',
      dontKnow: 'I don\'t know',
      unknown: 'Unknown answer',
      empty: '(empty)',
    },
    header: {
      intro: 'Level placement test',
      skillResult: 'Skill result',
      reviewAnswers: 'Review answers',
      results: 'Test results',
    },
    progress: {
      completedSkills: 'Skills completed: {{completed}} of {{total}}',
    },
    loadingResults: 'Loading results...',
    intro: {
      heading: 'Find out your English level',
      shortDesc: 'Quick test: listening and reading (~10-15 minutes) — for a rough level estimate. You can take the full test later from your profile for more precise results.',
      fullDesc: 'This test helps evaluate your skills across 4 key aspects of English:',
      resumeBanner: 'You have already completed {{completed}} of {{total}} skills. Continue the test!',
      remainingText: '{{remaining}} skills remaining. You can continue at any time.',
      shortTimeHint: 'The test takes about 10-15 minutes. The "Pronunciation" section requires a microphone.',
      fullTimeHint: 'Each test takes about 20-30 minutes. You will get a separate score for each skill and learn your true English level.',
      noUserError: 'Error: could not identify the user. Please try reloading the page.',
      continueTest: 'Continue the test',
      startTest: 'Start the test',
      viewResults: 'View results',
    },
    testing: {
      questionOf: 'Question {{current}} of {{total}}',
      videoNotLoaded: 'Video not loaded yet',
      answerPlaceholder: 'Answer {{index}}',
      pronunciationInstruction: 'Press the microphone button and say the word clearly aloud.',
      listening: 'Listening...',
      recorded: 'Done. You can re-record or continue.',
      pressToRecord: 'Press to record',
      weHeard: 'We heard:',
      pressToListen: 'Press to listen',
      fillGaps: 'Fill in the gaps:',
      writeCorrected: 'Write the corrected sentence:',
      correctedPlaceholder: 'Enter the corrected version...',
      finishSentence: 'Complete the sentence:',
      yourAnswerPlaceholder: 'Enter your answer...',
      saving: 'Saving...',
      nextQuestion: 'Next question',
      finishSkill: 'Finish skill',
    },
    skillResult: {
      completed: '{{skill}} - Completed!',
      yourLevel: 'Your level:',
      reviewAnswers: 'Review answers',
      skillsPassed: 'Skills completed: {{completed}} of {{total}}',
      viewAllResults: 'View all results',
      continueTest: 'Continue the test',
      finishLater: 'Finish later',
    },
    review: {
      backToResults: 'Back to results',
      unavailable: 'Answers are not available for review.',
      unavailableHint: 'Detailed review is only available right after taking the test.',
      question: 'Question {{index}}',
      correct: '✓ Correct',
      wrong: '✗ Wrong',
      sayWord: 'Say the word: {{word}}',
      sayWordWithPhonetic: 'Say the word: {{word}} {{phonetic}}',
      yourAnswer: 'Your answer:',
      correctAnswer: 'Correct answer:',
    },
    results: {
      testFinished: 'Test completed!',
      yourResults: 'Your results',
      resultsBySkill: 'Your results for each skill:',
      skillsPassedSummary: '{{completed}} of {{total}} skills completed',
      continueTest: 'Continue the test',
      close: 'Close',
      saveResults: 'Save results',
    },
  },
};

export default dict;
